import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const NetworkTitle = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${Screen.widthRatio * 44}px;
  top: ${Screen.widthRatio * 510}px;
  position: relative;
`;

export default NetworkTitle;
